//import images from 'assets/images/images'
import AccordionTab from 'components/accordion/AccordionTab'
import Button from 'components/form-elements/buttons/Button'
//import Accordion from "components/accordion/Accordion";
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useEffect, useRef, useState } from 'react'
import auth from 'utils/Auth'
import { useRequest } from 'hooks/useRequest'
import moment from 'moment'
import CurrencyFormatter from 'utils/CurrencyFormatter'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useEffectTrigger } from 'redux/features/general/generalSlice'
import ApprovalModal from 'components/approvalModal/ApprovalModal'
import StarRatings from 'react-star-ratings'
import LoaderTwo from './LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import Breadcrumbs from 'components/Breadcrumbs'
import { dataLayerPush } from 'utils/Datalayer'

const OrderCard = ({ order }) => {
	const navigate = useNavigate()
	const buttonRef = useRef()
	const [request, loading] = useRequest()
	const dispatch = useDispatch()
	const [approvalModal, setApprovalModal] = useState({ open: false, type: null })
	const [rating, setRating] = useState({ speedRating: 0, serviceRating: 0, tasteRating: 0 })
	const { t } = useTranslate()

	const statusOrderFunc = (status) => {
		switch (status) {
			case 5:
				return t('orderStatus5') // göremiyorum
			case 10:
				return t('orderStatus10') // 1 olacak
			case 20:
				return t('orderStatus20') //2
			case 30:
				return t('orderStatus30') //3
			case 40:
				return t('orderStatus40') //4
			case 50:
				return t('orderStatus50') // hepsi dolu + kırmızı
			case 60:
				return t('orderStatus60') // hepsi dolu + kırmızı
			case 70:
				return t('orderStatus70') // hepsi dolu + kırmızı
			default:
				break
		}
	}

	const statusStepFunc = (status) => {
		switch (status) {
			case 5:
				return 0
			case 10:
				return 1
			case 20:
				return 2
			case 30:
				return 3
			case 40:
				return 4
			case 50:
				return 4
			case 60:
				return 4
			case 70:
				return 4
			default:
				break
		}
	}

	const repeatOrder = () => {
		if (!auth.isHaveToken()) {
			return toast.error(t('cannotAddtoCart'))
		}
		request('/ShoppingCart/ClearCart', {
			method: 'POST',
			headers: {
				restaurantId: auth.getUserChoises()?.restaurantId,
				deliveryType: auth.getUserChoises()?.deliveryType,
				neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
				regionId: auth.getUserChoises()?.regionId,
			},
		}).then((res) => {
			if (res.data.ok) {
				request(`/Order/RepeatOrder/${order?.id}`, {
					method: 'POST',
					headers: {
						restaurantId: auth.getUserChoises()?.restaurantId,
						deliveryType: auth.getUserChoises()?.deliveryType,
						neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
						regionId: auth.getUserChoises()?.regionId,
					},
				}).then((res) => {
					if (res.data) {
						toast.success(t('productAddedToCart'))
						navigate('/odeme')
					}
				})
			}
		})
	}

	const deleteOrder = () => {
		request(`/Order/CancelOrder/${order?.id}`, {
			method: 'POST',
			headers: {
				restaurantId: auth.getUserChoises()?.restaurantId,
				deliveryType: auth.getUserChoises()?.deliveryType,
				neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
				regionId: auth.getUserChoises()?.regionId,
			},
		}).then((res) => {
			if (res.data) {
				toast.success(t('orderCancelingSuccess'))
				setApprovalModal({ type: null, open: false })
				dispatch(useEffectTrigger(Math.floor(Math.random() * 1000)))
				dataLayerPush({ ecommerce: null })
				dataLayerPush({
					event: 'refund',
					ecommerce: {
						item_list_name: 'Listeleme Sayfası',
						currency: 'TRY',
						items: [order]?.map((prev, i) => ({
							item_id: prev.productId,
							item_name: prev.productName,
							affilication: 'Tavuk Dünyası',
							discount: prev.discountAmount,
							index: i,
							item_brand: 'Tavuk Dünyası',
							item_list_name: 'Listeleme Sayfası',
							price: prev.unitPrice,
						})),
					},
				})
				// dataLayerPush({ ecommerce: null })
				// dataLayerPush({
				// 	event: 'refund',
				// 	ecommerce: {
				// 		item_list_name: 'Listeleme Sayfası',
				// 	},
				// })
			}
		})
	}

	const scoringOrder = () => {
		if (order?.isRated) {
			toast.error(t('allreadyRated'))
		} else {
			request('/Order/RateOrder', {
				method: 'POST',
				data: {
					orderId: order?.id,
					...rating,
				},
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res.data) {
					toast.success(t('rateSent'))
					setApprovalModal({ type: null, open: false })
				}
			})
		}
	}

	const orderDetailFunc = (e) => {
		const modalClass = window.document.getElementsByClassName('modal')[0]
		if (!buttonRef?.current?.contains(e.target) && !modalClass?.contains(e.target)) {
			navigate(`/siparis/${order?.id}`)
		}
	}

	const changeRating = (newRating, name) => {
		setRating((prev) => ({ ...prev, [name]: newRating }))
	}
	const parameters = auth.getUserChoises()
	const isRepeatOrderOpen =
		parameters?.deliveryType && parameters?.neighbourhoodId && parameters?.restaurantId && (parameters?.deliveryType == 1 || parameters?.regionId)
	const scoringContent = (
		<div className='scoringContent'>
			<div className='scoringContent-desc'>{order?.isRated ? '' : t('rateThanks')}</div>
			<div className='scoringContent-card'>
				<div className='scoringContent-card-title'>{t('orderSpeed')}</div>
				<StarRatings
					starSpacing='3px'
					starEmptyColor='#e2e2e2'
					starHoverColor='#f0c000'
					rating={order?.isRated ? order?.speedRating : rating.speedRating}
					starRatedColor='#f0c000'
					changeRating={order?.isRated ? null : changeRating}
					numberOfStars={5}
					name='speedRating'
				/>
			</div>
			<div className='scoringContent-card'>
				<div className='scoringContent-card-title'>{t('serviceQuality')}</div>
				<StarRatings
					starSpacing='3px'
					starEmptyColor='#e2e2e2'
					starHoverColor='#f0c000'
					rating={order?.isRated ? order?.serviceRating : rating.serviceRating}
					starRatedColor='#f0c000'
					changeRating={order?.isRated ? null : changeRating}
					numberOfStars={5}
					name='serviceRating'
				/>
			</div>
			<div className='scoringContent-card'>
				<div className='scoringContent-card-title'>{t('flavor')}</div>
				<StarRatings
					starSpacing='3px'
					starEmptyColor='#e2e2e2'
					starHoverColor='#f0c000'
					rating={order?.isRated ? order?.tasteRating : rating.tasteRating}
					starRatedColor='#f0c000'
					changeRating={order?.isRated ? null : changeRating}
					numberOfStars={5}
					name='tasteRating'
				/>
			</div>
		</div>
	)
	return (
		<div onClick={orderDetailFunc} className='ordercard'>
			<div className='ordercard-left'>
				{/* <div className='ordercard-left-onval'>{statusOrderFunc(order?.orderStatus)}</div> */}
				<AccordionTab title={statusOrderFunc(order?.orderStatus)} step={statusStepFunc(order?.orderStatus)} />
				<div className='ordercard-left-title'>{order?.orderItems.map((ord) => ord.productName + ', ')}</div>
				<div>
					<div className='ordercard-left-info'>
						<div className=''>{order?.orderItems?.map((image, i) => image?.pictureUrl && <img src={image?.pictureUrl} key={i} alt='' />)}</div>
						<div>
							<div className='orderDateTitle'>{t('orderDate')}</div>
							<div className='orderDateDesc'>
								{moment(order.createdDate).format().split('T')[0] + ' / ' + moment(order.createdDate).format().split('T')[1].split('+')[0]}
							</div>
						</div>
						<div>
							<div className='orderPriceTitle'>{t('totalAmount')}</div>
							<div className='orderPriceDesc'>
								<CurrencyFormatter locale='tr' currency='TRY' value={order.orderTotal} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div ref={buttonRef} className='ordercard-right'>
				{order.orderStatus == 10 && (
					<Button onClick={() => setApprovalModal({ type: 2, open: true })} className={'grayRoundedBtn'} text={t('cancelOrder')} />
				)}
				{isRepeatOrderOpen && (
					<Button onClick={() => setApprovalModal({ type: 1, open: true })} className={'claretredRoundedBtn'} text={t('repeatOrder')} />
				)}
				{order?.orderStatus == 40 && (
					<Button onClick={() => setApprovalModal({ type: 3, open: true })} className={'claretredRoundedBtn'} text={t('rateOrder')} />
				)}
			</div>

			<ApprovalModal
				desc={approvalModal.type == 3 && scoringContent}
				onClose={approvalModal.open}
				loading={loading}
				disabledButtons={order?.isRated && approvalModal.type != 1 && approvalModal.type != 2}
				title={
					approvalModal.type == 1
						? t('sureYouWantRepeatOrderOrder')
						: approvalModal.type == 2
						? t('sureYouWantCancelOrder')
						: `${order?.isRated ? t('orederRated') : t('rateOrder')}`
				}
				closeModal={() => setApprovalModal({ open: false, type: null })}
				onApproval={approvalModal.type == 1 ? repeatOrder : approvalModal.type == 2 ? deleteOrder : scoringOrder}
			/>
		</div>
	)
}

const Order = () => {
	const [request, loading] = useRequest()
	const [orders, setOrders] = useState([])
	const { useTrigger } = useSelector((state) => state.general)
	const { t } = useTranslate()

	const headerOptions = {
		RestaurantId: auth?.getUserChoises()?.restaurantId,
		DeliveryType: auth?.getUserChoises()?.deliveryType,
		NeighbourhoodId: auth?.getUserChoises()?.neighbourhoodId,
		RegionId: auth?.getUserChoises()?.regionId,
	}

	useEffect(() => {
		request('/Order', {
			method: 'GET',
			headers: headerOptions,
		}).then((res) => {
			if (res) {
				setOrders(res?.data?.result)
			}
		})
	}, [useTrigger])

	return (
		<div className='orders'>
			<Helmet>
				<title>{t('myorders')}</title>
			</Helmet>
			<LoaderTwo isDataLoading={loading} />
			<Breadcrumbs
				className={'breadcrumbs'}
				breadcrumbList={[
					{ text: t('homePage'), link: '/' },
					{ text: t('myorders'), link: '/' },
				]}
			/>
			<div className='orders-container'>
				<h1 className='header-m2'>{t('myorders')}</h1>
				{loading && (
					<>
						<div className='ordercard'>
							<div className='skeleton p-5'></div>
						</div>
						<div className='ordercard'>
							<div className='skeleton p-5'></div>
						</div>
					</>
				)}
				{orders.length > 0 &&
					orders?.sort((a, b) => moment(b.createdDate) - moment(a.createdDate)).map((order, i) => <OrderCard key={i} step={3} order={order} />)}
				{/* <Accordion title='Kendini Beğenmiş Köfte, Akdenizlim Salata, Fındıklı Fırın Sütlaç' step={3} onval="Teslimatta" /> */}
				{/* <Button className={"grayRoundedBtn orderThan"} icon={BsArrowRight} text={"Fazlası"}/> */}
				{orders.length == 0 && !loading && <div className='body-m text-center py-4 text-orange'>{t('emptyOrderText')}</div>}
			</div>
		</div>
	)
}

export default Order
